import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/thankyou.webp'


const _hoisted_1 = { class: "w-[664px] max-w-full mx-auto px-8 md:px-0" }
const _hoisted_2 = { class: "w-full flex flex-col md:flex-row mt-32 md:items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-48 md:max-w-[224px] mx-auto" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_4 = { class: "md:ml-auto" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-[42px] md:text-[52px] font-bold font-georgian text-green leading-tight" }, " Thank you ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-[20px] md:text-2xl font-georgian font-bold text-green leading-relaxed mb-2.5 md:mb-5" }, " for contacting Perfect Green! ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-secondary-gray text-base leading-[42px] mb-10 md:mb-14" }, " We will be in touch shortly ", -1)
const _hoisted_8 = { href: "" }

import FilledButton from "@/components/common/filled-button.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ThankYou',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("a", _hoisted_8, [
          _createVNode(FilledButton, null, {
            default: _withCtx(() => [
              _createTextVNode("Back to Homepage")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})